
import { Injectable } from '@angular/core';
import { snackbarService } from '@one/web-components';
import { BehaviorSubject, Observable } from 'rxjs';

export interface qnsbnStack {
  recipientData: {},
  localNotificationId: {},
  notificationDoc: {},
  notificationDocFileList: {},
  configureFeedback: {},
  messageAttachment: {},
  reminderAttachment: {},
  messageAttachmentFileList: {},
  notificationReminders: {},
  feedbackDueDate: any,
  template: boolean,
  notificationRowData: {},
  dueDateEnabled: boolean,
  feedbackEnabled: boolean,
  dailyReportContent: any,
  dailyReportSendTo: any,
  enableDailyReport: boolean,
  documentEnabled: boolean
}

@Injectable({
  providedIn: 'root'
})
export class QnSbnDataServiceService {

  snackBarMessage(status:any,message:string){
      snackbarService.show({
        message: message, 
        snackbarProps: {
          status: status,
          direction: 'horizontal',
          showClose: true,
          elevated: false,
          duration: 5000,
          verticalPlacement: 'top',
          horizontalPlacement: 'right',
        }
      });
    }

  public template: boolean = false;

  storageForQnsbn: qnsbnStack = {
    recipientData: {},
    localNotificationId: {},
    notificationDoc: {},
    notificationDocFileList: {},
    configureFeedback: {},
    messageAttachment: {},
    reminderAttachment: {},
    messageAttachmentFileList: {},
    feedbackDueDate: {},
    notificationReminders: {},
    template: this.template,
    notificationRowData: {},
    dueDateEnabled: true,
    feedbackEnabled: true,
    documentEnabled: true,
    dailyReportContent: {},
    dailyReportSendTo: {},
    enableDailyReport: true

  };

 public DueDateEnabled$ = new BehaviorSubject(true);
  public FeedbackEnabled$ = new BehaviorSubject(true);
  public DailyReportEnabled$ = new BehaviorSubject(false);
  public isAfoBtnDisabled$ = new BehaviorSubject<boolean>(false);
  public isValidFeedback$ = new BehaviorSubject<boolean>(false);
  public fbDisabledAndEnabled$ = new BehaviorSubject<boolean>(false);
  public isFeedbackAdded$ = new BehaviorSubject<boolean>(false);
  public isEdited$ = new BehaviorSubject<boolean>(false);
  public DocumentEnabled$ = new BehaviorSubject(true);
  public hideActionBar$ = new BehaviorSubject<boolean>(false);

  public setDDToggle(d){
    this.storageForQnsbn.dueDateEnabled = d;
    this.DueDateEnabled$.next(d);
  }

  public setFBToggle(d){
    this.storageForQnsbn.feedbackEnabled = d;
    this.FeedbackEnabled$.next(d);
  }

   public setDRToggle(d){
    this.storageForQnsbn.enableDailyReport = d;
    this.DailyReportEnabled$.next(d);
  }

   public setDocumentToggle(d){
    this.storageForQnsbn.documentEnabled = d;
    this.DocumentEnabled$.next(d);
  }

  // Observable string sources
  private mappingqnsbnDataSource = new BehaviorSubject<object>({});

  // Observable string streams
  public mappingData$ = this.mappingqnsbnDataSource.asObservable();

  // Service message commands
  public getMappedQnsbnData(d: object, source): void {
    switch (source) {
      case 'Recipient':
        this.storageForQnsbn.recipientData = d;
        // console.log("d",d);
        
        this.mappingqnsbnDataSource.next(this.storageForQnsbn);
        return;
      case 'LocalNotificationId':
        this.storageForQnsbn.localNotificationId = d;
        // console.log("d",d);
        
        this.mappingqnsbnDataSource.next(this.storageForQnsbn);
        return;
      case 'NotificationDoc':
        this.storageForQnsbn.notificationDoc = d;
        this.mappingqnsbnDataSource.next(this.storageForQnsbn);
        return;
      case 'NotificationDocFileList':
        this.storageForQnsbn.notificationDocFileList = d;
        this.mappingqnsbnDataSource.next(this.storageForQnsbn);
        return;
      case 'ConfigureFeedBack':
        this.storageForQnsbn.configureFeedback = d;
        this.mappingqnsbnDataSource.next(this.storageForQnsbn);
        return;
      case 'MessageAttachment':
        this.storageForQnsbn.messageAttachment = d;
        this.mappingqnsbnDataSource.next(this.storageForQnsbn);
        return;
      case 'reminderAttachment':
        this.storageForQnsbn.reminderAttachment = d;
        this.mappingqnsbnDataSource.next(this.storageForQnsbn);
        return;
      case 'MessageAttachmentFileList':
        this.storageForQnsbn.messageAttachmentFileList = d;
        //27/2/2023 removed this.storageForQnsbn.messageAttachmentFileList with this.storageForQnsbn which was having issue on saving data 
        this.mappingqnsbnDataSource.next(this.storageForQnsbn);
        return;
      case 'FeedbackDueDate':
        this.storageForQnsbn.feedbackDueDate = d;
        this.mappingqnsbnDataSource.next(this.storageForQnsbn);
        return;
      case 'NotificationReminders':
        this.storageForQnsbn.notificationReminders = d;
        this.mappingqnsbnDataSource.next(this.storageForQnsbn);
        return;
      case 'DraftNotification':
        this.storageForQnsbn.notificationRowData = d;
        this.mappingqnsbnDataSource.next(this.storageForQnsbn);
        return;
      case 'DailySummaryReportContent':
        this.storageForQnsbn.dailyReportContent = d;
        this.mappingqnsbnDataSource.next(this.storageForQnsbn);
        return;
      case 'DailySummaryReportSendTo':
        this.storageForQnsbn.dailyReportSendTo = d;
        this.mappingqnsbnDataSource.next(this.storageForQnsbn);
        return;
      default:
        return;
    }

  }
  
  public resetAll() {
    this.storageForQnsbn = {
      recipientData: {},
      localNotificationId: {},
      notificationDoc: {},
      notificationDocFileList: {},
      configureFeedback: {},
      messageAttachment: {},
      reminderAttachment: {},
      messageAttachmentFileList: {},
      feedbackDueDate: {},
      notificationReminders: {},
      template: false,
      notificationRowData: {},
      dueDateEnabled: true,
      feedbackEnabled: true,
      documentEnabled: true,
      dailyReportContent: {},
      dailyReportSendTo: {},
      enableDailyReport: true

    };
    this.mappingqnsbnDataSource.next({});
    
    this.DueDateEnabled$.next(true);
    this.FeedbackEnabled$.next(true);
    this.DocumentEnabled$.next(true);
    this.DailyReportEnabled$.next(false);
  }
  //Check {} object is Empty.
  public isEmpty(obj) {
    return !(() => {
      for (const i in obj) {
        return true;
      }
      return false;
    })();
  }

  public saveNcloseData(data) {
    let arrayForRecipientAPI = []
    if (Array.isArray(data.recipientData['recipientTable']) && data.recipientData['recipientTable'].length > 0) {
      arrayForRecipientAPI = data.recipientData['recipientTable'].map(rec => {
        let custId = rec['customerId'] ? rec['customerId'].trim() : '';
        let custEmail = rec['customerEmail'] ? rec['customerEmail'].trim() : '';
        let sendInAPIFormat = {
          "Title": data.localNotificationId['Title'] || "",
          "Type": data.localNotificationId['Type'] || "",
          "CustomerId": custId,
          "CustomerName": rec['customerName'],
          "CustomerContactName": rec['customerContactName'],
          "CustomerContactEmail": custEmail,
          "DataSource": rec['sourceName'],
          "Status": "",
          "DateReceived": "",
          "DeadlineFeedback": data.feedbackDueDate['feedbackDueDate'] || "",
          "DateDelivered": "",
          "DateRead": "",
          "FeedbackReceived": "",
          "FeedbackDueDate": data.dueDateEnabled? data.feedbackDueDate['feedbackDueDate'] || "" : "",
          "DueDateEnabled": data.dueDateEnabled,
          "FeedbackEnabled": data.feedbackEnabled,
          "DailyReportContent": data.enableDailyReport? data.dailyReportContent || {} : {},
          "DailyReportSendTo": data.enableDailyReport? data.dailyReportSendTo.sendTo || {} : {},
          "EnableDailyReport": data.enableDailyReport,
        }
        return sendInAPIFormat;
      })
    }

    let arrayForConfigureFeedbackAPI = []
    if (Array.isArray(data.configureFeedback) && data.configureFeedback.length > 0) {
      arrayForConfigureFeedbackAPI = data.configureFeedback.map((rec, index = 1) => {
        let sendInConfigAPIFormat = {
          "FeebackItemId": index,
          "FeedbackItemLabel": rec['selectText'],
          "FeedbackItemType": rec['selectType'],
          "FeedbackItemMandatory": rec['selectMandatory'],
          "FeedbackItemDropdown": rec['selectType'] === 'Radio' ? [] : (rec['FeedbackItemDropdown'] || rec['dropDownOpt'] || []),
          "FeedbackItemRadio": rec['selectType'] === 'Radio' ? (rec['FeedbackItemRadio'] || rec['radioOpt'] || []) : []
        }
        return sendInConfigAPIFormat;
      })
    }

    let arrayForNotificationAttachments = [];
    let arrayForNotificationDocAttachments = []
    if (data.documentEnabled && Array.isArray(data['notificationDocFileList']) && data['notificationDocFileList'].length > 0) {
      arrayForNotificationDocAttachments = data.notificationDocFileList.map((rec) => {
        let sendInConfigAPIFormat = {
          "FileName": rec['name'],
          "FileSize": rec['size'],
          "NotificationDoc": true
        }
        return sendInConfigAPIFormat;
      })
    }
    if (Array.isArray(data.messageAttachmentFileList.fileList) && data.messageAttachmentFileList.fileList.length > 0) {
      arrayForNotificationAttachments = data.messageAttachmentFileList.fileList.map((rec) => {
        let sendInConfigAPIFormat = {
          "FileName": rec['name'],
          "FileSize": rec['size'],
          "NotificationDoc": false
        }
        return sendInConfigAPIFormat;
      })
    }

    let arrayForNotificationRemindersAPI = []
    if (Array.isArray(data.notificationReminders['remindersData']) && data.notificationReminders['remindersData'].length > 0) {
      arrayForNotificationRemindersAPI = data.notificationReminders['remindersData'].map((rec, index = 1) => {
        let sendInRemindersAPIFormat = {
          "ReminderId": index,
          "ReminderDueDate": rec['reminderDate'],
          "ReminderSubject": rec['reminderSubject'],
          "ReminderMessage": rec['reminderMessage'],
          "ReminderAddTemplate": "",
          "ReminderSendAutomatically": true // rec['reminderSendMode'] === '0' ? true : false
        }
        return sendInRemindersAPIFormat;
      })
    }

    let requestPayloadData = {
      "NotificationId": data.localNotificationId['NotificationId'] || "",
      "Type": data.localNotificationId['Type'] || "",
      "Title": data.localNotificationId['Title'] || "",
      "GlobalId": data.localNotificationId['GlobalId'] || "",
      "GlobalNotificationId": data.localNotificationId['GlobalNotificationId'] || "",
      "MessageTitle": data.messageAttachment['subjectName'] || "",
      "MessageBody": data.messageAttachment['messageAttachmentRTEText'] || "",
      "ReminderTitle": data.reminderAttachment['reminderSubjectName'] || "",
      "ReminderBody": data.reminderAttachment['reminderAttachmentRTEText'] || "",
      "TemplateId": data.messageAttachment['templateId'] || "",
      "FeedbackDueDate": data.dueDateEnabled? data.feedbackDueDate['feedbackDueDate'] || "" : "",
      "NotificationDocuments": data.documentEnabled ? [data.notificationDoc || {}] : [],
      "CustomerFeedbackItems": data.feedbackEnabled? arrayForConfigureFeedbackAPI : [],
      "NotificationContacts": arrayForRecipientAPI,
      "NotificationReminders": data.dueDateEnabled? arrayForNotificationRemindersAPI : [],
      "Country": data.localNotificationId['Country'] || "",
      "LocalNotificationLanguage": data.localNotificationId['LocalNotificationLanguage'] || "",
      "CreationDate": data.localNotificationId['CreationDate'] || "",
      "LocalId": data.localNotificationId['LocalId'] || "",
      "Status": data.localNotificationId['Status'] || "",
      "UserId": data.localNotificationId['UserId'] || "",
      "UserRole": data.localNotificationId['UserRole'] || "",
      "NotificationAttachments": arrayForNotificationDocAttachments.concat(arrayForNotificationAttachments),
      "DocumentEnabled": data.documentEnabled,
      "DueDateEnabled": data.dueDateEnabled,
      "FeedbackEnabled": data.feedbackEnabled,
      "DailyReportContent": data.enableDailyReport? data.dailyReportContent || {} : {},
      "DailyReportSendTo": data.enableDailyReport? data.dailyReportSendTo.sendTo || {} : {},
      "EnableDailyReport": data.enableDailyReport,
    }
    return requestPayloadData;
  }

   public fileUploadData(data) {
    if(!this.isEmpty(data)){
      let fileData = [];
      if (data.documentEnabled) {
        if (Array.isArray(data['notificationDocFileList']) && data['notificationDocFileList'].length > 0) {
          fileData = data['notificationDocFileList'];
        }
      }
      if (Array.isArray(data['messageAttachmentFileList']['fileList']) && data['messageAttachmentFileList']['fileList'].length > 0) {
        if (fileData.length == 0) {
          fileData = data['messageAttachmentFileList']['fileList'];
        } else {
          fileData = [...fileData, ...data['messageAttachmentFileList']['fileList']]
        }
      }
      return fileData;
    }else{
      return [];
    }
  }
  public setDueDateAndReminderData(dueDate, reminderTable): void {
    if(this.storageForQnsbn.dueDateEnabled){
      this.storageForQnsbn.feedbackDueDate['feedbackDueDate'] = dueDate;
      this.storageForQnsbn.notificationReminders['remindersData'] = reminderTable;
    }
    // this.mappingqnsbnDataSource.next(this.storageForQnsbn);
  }

}
